import { z } from 'zod';

export interface AlgoliaFilterItem {
  end?: number;
  label: string;
  start?: number;
  value: string;
}

export const AlgoliaFacet = z.record(z.string(), z.number()).optional();
export type AlgoliaFacet = z.infer<typeof AlgoliaFacet>;
